export const ChevronLeftIcon = ({ className }: { className?: string }) => (
  <svg
    className={className}
    width="21"
    height="22"
    viewBox="0 0 21 22"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M14.117 17.883 7.233 11l6.884-6.883"
      stroke="currentColor"
      strokeWidth="2.74"
    />
  </svg>
);
